import { Button } from '@idexx-laboratories/spot-react';
import { runInAction } from 'mobx';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { GridRendererProps } from '../../components/Grid/Grid';
import SelectBoxOptions from '../../components/SelectBoxOptions/SelectBoxOptions';
import { useStore } from '../../hooks/use-store';
import { PracticeSpeciesBreeds } from '../../types/species-breeds-types';
import { isDefined, sortByField } from '../../utils/object-utils';

export const VendorSpeciesRenderer = observer((props: GridRendererProps<PracticeSpeciesBreeds>) => {
  const { row, index } = props;
  const { manageSpeciesStore: store, globalStore } = useStore();

  const values = [
    { id: undefined, name: 'Select Species' },
    ...sortByField(Object.values(globalStore.vendorSpeciesBreeds), 'name').map(s => ({
      id: s.id,
      name: s.name,
    })),
  ];
  const changeSpecies = (vendorIndex: number) => {
    runInAction(() => {
      if (isDefined(store.currentItemIndex)) {
        store.currentValue = values[vendorIndex].id;
      } else {
        row.vendorItemId = values[vendorIndex].id;
        store.hasUnsavedChanges = true;
      }
    });
  };

  return (
    <SelectBoxOptions
      values={values}
      displayField='name'
      onChange={idx => changeSpecies(idx)}
      selectedIndex={values.findIndex(
        vs => vs.id === (store.currentItemIndex === index ? store.currentValue : row.vendorItemId),
      )}
      disabled={store.singleItemEditMode ? store.currentItemIndex !== index : row.editDisabled}
    />
  );
});

export const ActionsRenderer = observer(
  (props: GridRendererProps<PracticeSpeciesBreeds> & { index: number }) => {
    const { row, index } = props;
    const { manageSpeciesStore: store } = useStore();

    if (store.singleItemEditMode && store.currentItemIndex === index)
      return (
        <>
          <Button
            iconOnly='save'
            variant='link'
            size='small'
            onClick={() => void runInAction(() => store.saveItem(index))}
            title='Save'
            aria-label='save'
            disabled={store.loaders.saveSingle}
            data-testid={`save-${row.id}-btn`}
          />
          <Button
            iconOnly='cancel'
            variant='link'
            size='small'
            onClick={() => runInAction(() => (store.currentItemIndex = undefined))}
            title='Cancel'
            aria-label='cancel'
            disabled={store.loaders.saveSingle}
            data-testid={`cancel-${row.id}-btn`}
          />
        </>
      );

    return (
      <Button
        iconOnly='edit'
        size='small'
        variant='link'
        disabled={store.singleItemEditMode ? isDefined(store.currentItemIndex) : !row.editDisabled}
        onClick={() =>
          runInAction(() => {
            if (store.singleItemEditMode) {
              store.currentItemIndex = index;
              store.currentValue = row.vendorItemId;
            } else {
              row.editDisabled = false;
            }
          })
        }
        title='Edit species'
        aria-label='edit-species'
        data-testid={`edit-${row.id}-btn`}
      />
    );
  },
);

export const MessageMapBreeds = (): React.JSX.Element => (
  <>
    Click <strong>Manage Breeds</strong> to complete setup and send
    <br />
    the information to your Cornerstone server.
  </>
);
